<template>
	<div style="display: flex;justify-content: space-between;align-items: end;">
		<div style="margin-bottom: 10px;">Total <strong class="text-blue">{{ items.length }}</strong> 건</div>
		<div v-if="actionBatch">
			<div class="searchRow">
				<div class="searchCont">
					<select v-model="actions" id="action" @change="getActionText($event)">
						<option value="">관리상태 선택</option>
						<option value="accept">선택 수락</option>
						<option value="reject">선택 거절</option>
						<option value="cancel">선택 취소</option>
					</select>
				</div>
				<div>
					<button type="button" class="search_btn" @click="manageBatch()">저장</button>
				</div>
			</div>
		</div>
	</div>
	<table>
		<thead>
			<tr>
				<th v-if="showNum">No</th>
				<th v-if="hasCheck"><input type="checkbox" @click="toggleAll($event)" id="chk_all"></th>
				<th v-for="header in headers" :key="header">{{ header.label }}</th>
			</tr>
		</thead>
		<tbody :class="HZwrapper">
			<tr v-if="paginatedItems.length > 0" v-for="item, index in paginatedItems" :key="item.id" v-show="item.show"
				class="tableItem">
				<td v-if="showNum">{{ paginatedItems.length - index }}</td>
				<!-- <td v-if="hasCheck"><input type="checkbox" class="chk" :value="getValue(item, checkedField)" :data-id="item.id" :data-issend="item.isSend" @change="handleCheckboxChange()"></td> -->
				<td v-if="hasCheck"><input type="checkbox" class="chk" v-model="item.checked" :data-id="item.id" :data-issend="item.isSend" @change="handleCheckboxChange()"></td>

				<td v-for="header in headers" :key="header.key">
					<router-link v-if="header.key === 'board_subject'"
						:to="{ name: 'BoardView', params: { id: item.real_id, type: item.board_type } }" class="board_subject">
						{{ getValue(item, header.key) }}
						<span class="newIcon">N</span>
					</router-link>
					<!-- <template v-else-if="header.key === 'request_recv_date'">
						{{ getValue(item, header.key) }}
					</template> -->

					<template v-else-if="header.key === 'unmatch'" v-for="(aiorder, idx) in filteredAiorders(item)"
						:key="idx">
						<button type="button" v-if="aiorder.show" class="charge_bils charge_bils4"
							@click="unmatch(item.partner.mb_boss_id, item.partner.mb_nick)">
							매칭 해제
						</button>
						<div v-else class="charge_bils">-</div>
					</template>

					<template v-else-if="header.key === 'manage'" v-for="(aiorder, idx2) in filteredAiorders(item)"
						:key="idx2">
						<button type="button" v-if="item.isSend" class="charge_bils charge_bils4"
							@click="manage(item.id, item.partner.mb_boss_id, item.partner.mb_nick, 'cancel')">
							취소
						</button>
						<div v-else>
							<button type="button" class="charge_bils charge_bils1"
								@click="manage(item.id, item.partner.mb_boss_id, item.partner.mb_nick, 'accept')">
								수락
							</button>
							&nbsp;
							<button type="button" class="charge_bils charge_bils3"
								@click="manage(item.id, item.partner.mb_boss_id, item.partner.mb_nick, 'reject')">
								거절
							</button>
						</div>
					</template>
					<span v-else>{{ getValue(item, header.key) }}</span>
				</td>
			</tr>
			<tr v-else>
				<td colspan="99">데이터가 없습니다.</td>
			</tr>
		</tbody>
	</table>

	<div class="page">
		<ul :id="HZpaginationId" class="pagination">
			<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
			<li>
				<ul class="num_wrap">
					<li v-for="page in pagesToShow" :key="page"
						:class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']"
						@click="goToPage(page)">
						{{ page }}
					</li>
				</ul>
			</li>
			<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
		</ul>
	</div>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import * as commonjs from '@/components/utils/common';
import { boolean } from 'yup';

// Props
const props = defineProps({
	headers: {
		type: Array,
		required: true
	},
	itemsData: {
		type: Array,
		required: true
	},
	perPage: {
		type: Number,
		default: 10
	},
	showNum: {
		type: Boolean,
		default: false
	},
	showNew: {
		type: String,
		default: false
	},
	hasCheck: {
		type: Boolean,
		default: false
	},
	actionBatch: {
		type: Boolean,
		default: false
	},
	checkedField: {
		type: String,
		required: false
	},
	dateFormat: {
		type: String,
		required: false
	},
	dateTarget: {
		type: String,
		required: false
	},
});

const emit = defineEmits(['unmatch']);

const items = ref([]);

const HZwrapper = 'paginationTable';
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / props.perPage));

const getValue = (item, key) => {
	//if (key === 'request_recv_date') {
	//	const dateKey = item.isSend ? 'send_datetime' : 'recv_datetime';
	//	return formatDate(item[dateKey], props.dateFormat);
	//} else {
	const value = key.split('.').reduce((acc, cur) => acc && acc[cur], item);
	if (key === 'board_subject') {
		// if (commonjs.dateFormatYMD(item.createdAt) === moment().format('YYYY-MM-DD')) {
		// value = 'N'+value;
		// }
		return value;
	}

	if (key === props.dateTarget) {
		return formatDate(value, props.dateFormat);
	} else {
		return value;
	}
}

const filteredAiorders = (item) => {
	//console.debug('filteredAiorders().item', item);
	const aiorders = item?.partner?.aiorders || [];
	let show = true; // 조건을 만족하지 않으면 false로 설정

	for (const aiorder of aiorders) {
//		console.log('aiorder: ', aiorder);
		
		// 조건에 하나라도 맞지 않으면 show를 false로 설정
		if (
			!(aiorder?.order_status === 'ords3' && aiorder?.bill_status === 'bils1' && aiorder?.calc_status === 'type2') && !(aiorder?.order_status === 'ords4')
		) {
			console.log('aiorder if: ', aiorder);
			show = false;
			break; // 조건을 만족하지 않으면 반복문 중단
		}
	}

	// 모든 조건을 만족하면 show = true, 그렇지 않으면 false
	return [{ show }];
};

const formatDate = (date, formatStr) => {
	return moment(date).format(formatStr);
};

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * props.perPage;
	const end = start + props.perPage;
	return items.value.slice(start, end);
});

const loadItems = () => {
	currentPage.value = 1; // 240822 1페이지로 고정
	items.value = props.itemsData.map(item => ({ ...item, show: true }));
};

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const checkboxes = ref([]);

const handleCheckboxChange = () => {
	//checkboxes.value = Array.from(document.querySelectorAll('.chk:checked'));
	checkboxes.value = items.value.filter(item => item.checked); // item.checked로 체크 상태를 관리
};

const toggleAll = (event) => {
	const isChecked = event.target.checked;
	items.value.forEach(item => item.checked = isChecked);
	handleCheckboxChange();
};

const checkedCount = computed(() => checkboxes.value.length);

const isSendCheckedCount = computed(() => {
	return checkboxes.value.filter(checkbox => checkbox.dataset.issend === 'true').length;
});

/*
const allIsSendEqual_old = computed(() => {
	const checkedCheckboxes = document.querySelectorAll('.chk:checked');
	if (checkedCheckboxes.length === 0) return true;

	const firstIsSend = checkedCheckboxes[0].dataset.issend;
	return Array.from(checkedCheckboxes).every(chk => chk.dataset.issend === firstIsSend);
});
*/

const allIsSendEqual = computed(() => {
	// 체크된 항목 필터링
	const checkedItems = items.value.filter(item => item.checked);
	if (checkedItems.length === 0) return true;

	// 첫 번째 체크된 항목의 isSend 값
	const firstIsSend = checkedItems[0].isSend;
	// 모든 체크된 항목이 같은 isSend 값을 가지는지 확인
	return checkedItems.every(item => item.isSend === firstIsSend);
});


const unmatch = (id, nick) => {
	emit('unmatch', id, nick);
}

const manage = (idx, mb_boss_id, nick, action) => {
	emit('manage', idx, mb_boss_id, nick, action);
}

const actions = ref('');
const actionsText = ref();
const getActionText = (event) => {
	const selectedIndex = event.target.selectedIndex;
	actionsText.value = event.target.options[selectedIndex].text.split(' ')[1];
}

const validateBatchAction = () => {
	if (checkboxes.value.length === 0) return false;

	// 첫 번째 체크된 항목의 isSend 값 사용
	const firstIsSend = checkboxes.value[0].isSend;

	if (allIsSendEqual.value) {
		if (firstIsSend === true && actions.value === 'cancel') {
			return true;
		} else if (firstIsSend === false && (actions.value === 'accept' || actions.value === 'reject')) {
			return true;
		}
	}

	return false;
};

const manageBatch = async () => {
	if (!actions.value) {
		commonjs.formSwal('필수 선택', '일괄처리를 선택해주세요', '#action', 'self');
		return false;
	}
	const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
	// enabledInputs의 길이를 카운팅합니다.
	const count = enabledInputs.length;
	if (count < 1) {
		commonjs.formSwal('필수 선택', '일괄처리 할 항목을 하나 이상 선택해주세요.', '#chk_all', 'self');
		return false;
	}
	/*
	const firstIsSend = document.querySelectorAll('.chk:checked')[0].dataset.issend;

console.debug('allIsSendEqual', allIsSendEqual);

	// 일괄처리 오류
	if (allIsSendEqual.value) {
console.debug(allIsSendEqual.value);
		if (firstIsSend === 'true' && actions.value === 'cancel') {
console.log('보내고 취소');
		} else if (firstIsSend === 'false' && (actions.value === 'accept' || actions.value === 'reject')) {
console.log('받고 수락/거절');
		} else {
			commonjs.formSwal(`일괄 처리 오류`, `일괄 처리 할 값이 올바르지 않습니다.`, `#action`, `self`);
			return false;
		}
	} else {
		let msg = "";
		if (actions.value === 'accept' || actions.value === 'reject') {
			msg = `내가 [요청한] 내역은 [${actionsText.value}]할 수 없습니다.`;
		} else {
			msg = `내가 [요청받은] 내역은 [${actionsText.value}]할 수 없습니다.`;
		}
		commonjs.formSwal(`일괄 처리 오류`, msg, `#action`, `self`);
		return false;
	}
	*/

	if (!validateBatchAction()) {
		commonjs.formSwal('일괄 처리 오류', '일괄 처리 할 값이 올바르지 않습니다.', '#action', 'self');
		return false;
	}

	const batch_confirm = await commonjs.confirmSwal(`일괄처리 확인`, `선택된 항목들을 [${actionsText.value}] 처리 하시겠습니까?\n이 작업은 취소할 수 없습니다.`, `nl`);
	if (!batch_confirm) {
		return false;
	}
	// 메세지까지 가져옴
	emit('manageBatch', checkboxes.value, actions.value);
}

watch(() => props.itemsData, loadItems, { immediate: true });

onMounted(() => {
	loadItems();
});

/*
const tooltip = () => {
	const cantUnmatch = document.querySelector('.cant_unmatch');
	if (cantUnmatch) {
		cantUnmatch.addEventListener('mouseover', function (event) {
			document.querySelector('.authorityTxt').classList.add('active');
		});

		cantUnmatch.addEventListener('mouseout', function (event) {
			document.querySelector('.authorityTxt').classList.remove('active');
		});
	}
}
	*/
</script>